<template>
  <section class="content">
    <Card>
      <template #content>
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label>Month</label>
              <Dropdown v-model="month" optionLabel="key" placeholder="Select One"
                        :filter="true"
                        :options="monthList"
                        :showClear="true" id="account"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label>Month</label>
              <Dropdown v-model="year" optionLabel="key" placeholder="Select One"
                        :filter="true"
                        :options="yearList"
                        :showClear="true" id="account"/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <Button class="p-button-raised p-mt-5"
                      @click.prevent="searchSalaryReport" icon="pi pi-search" label="Search"/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <Button class="p-button-raised p-button-secondary p-mt-5"
                      @click.prevent="resetBtn" label="Reset"/>
            </div>
          </div>
        </form>
        <DataTable :paginator="true" :rows="10" :value="monthList"
                   class="p-datatable-responsive-demo p-datatable-gridlines">
          <Column header="S.N">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column header="Name" :sortable="true" field="name" filterMatchMode="contains">

          </Column>
          <Column header="Type" :sortable="true" field="payHeadType" filterMatchMode="contains">

          </Column>
          <Column header="Cal Type" :sortable="true" field="calculationType" filterMatchMode="contains">

          </Column>
          <Column header="Marital Status" :sortable="true" field="maritalStatus" filterMatchMode="contains">

          </Column>
          <Column header="Cr Account" :sortable="true" filterMatchMode="contains">
          </Column>
          <template #empty>No record found</template>
          <Column header="Action">
            <template #body="slotProps">
              <!-- Edit Button -->
              <Button icon="pi pi-eye" class="p-button-raised p-button-success"
                      @click="viewSalaryDetail(slotProps.data)"/>
              <!-- Edit button -->
              <!-- DeleteButton -->
              <Button class="p-button-raised p-button-danger"
                      @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
            </template>
          </Column>
        </DataTable>
      </template>
    </Card>
    <Dialog header="Salary Detail" :visible.sync="salaryDetail"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

      <DataTable :paginator="true" :rows="10" :value="monthList">
        <Column header="S.N">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column header="Provident fund">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column header="Basic Salary">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column header="TDS">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button class="p-button-raised p-button-danger" label="Cancel"
                @click.prevent="cancel"/>
      </template>
    </Dialog>
  </section>
</template>
<script>
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'

export default {
  name: 'SalaryReport',
  data() {
    return {
      month: null,
      year: null,
      monthList: [{key: 'बैशाख', value: 1}, {key: 'जेठ', value: 2}, {key: 'अषाढ', value: 3}, {
        key: 'श्रावण ',
        value: 4
      },
        {key: 'भाद्र', value: 5}, {key: 'आश्विन', value: 6}, {key: 'कार्तिक', value: 7}, {
          key: 'मङ्सिर',
          value: 8
        },
        {key: 'पौष', value: 9}, {key: 'माघ', value: 10}, {key: 'फाल्गुन', value: 11}, {
          key: 'चैत्र',
          value: 12
        }],
      yearList: [{key: '2077', value: 2077}, {key: '2078', value: 2078}],
      salaryDetail: false
    }
  },
  methods: {
    resetBtn() {
      this.month = null
      this.year = null
    },
    viewSalaryDetail() {
      this.salaryDetail = true
    },
    openDeleteDialog() {
    },
    cancel() {
      this.salaryDetail = false
    }
  },
  components: {
    Button,
    DataTable,
    Column,
    Card,
    InputText,
    Dropdown,
    Dialog
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SalaryReport.vue?9011e1f6